import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  text: {
    marginBottom: theme.spacing(2),
  },
  button: {
    padding: '6px 8px !important',
  },
  modalTitle: {
    fontFamily: 'Futura PT',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '20px',
    lineHeight: '160%',
    letterSpacing: '0.15px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  siteList: {
    listStyle: 'none',
    paddingLeft: 0,

    '& li': {
      '&::before': {
        content: '"\\2022"',
        color: '#BDB280',
        fontWeight: 'bold',
        display: 'inline-block',
        width: '1.5rem',
      },
    },
  }
}));
